import React, { useState } from "react";
import QurealSection from "../common/QurealSection";
import SectionHeader from "../components/commons/SectionHeader";
import { FileImageOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Input, Space } from "antd";
import { useTestq0, useTestq0Image } from "../_actions/q0";
import log from "cslog";
import QurealCanvas from "../qmade/creator/QurealCanvas";
import { MessageCodeView } from "../ai_home/ChatBox";
import ImagePicker from "../editor/imagepicker/ImagePicker";
import { getImageURL, getPublicImageURL } from "../_helpers/image";

const { TextArea } = Input;

function QZeroTest({ me }) {
    const [prompt, setPrompt] = useState("");
    const [img, setImg] = useState(null);
    const [result, setResult] = useState(null);

    const mutation = useTestq0((res) => {
        log.d(res, "result");
        if (res?.success) {
            setResult({
                ...res?.data?.data,
                id: res?.data?.id,
            });
        }
    });
    const mutationImg = useTestq0Image((res) => {
        log.d(res, "result img");
        if (res?.success) {
            setResult({
                ...res?.data?.data,
                id: res?.data?.id,
            });
        }
    });

    return (
        <QurealSection
            header={
                <SectionHeader heading="q0 test" icon={<FileImageOutlined />} />
            }
        >
            <div style={{ padding: "1rem" }}>
                <div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: "10px",
                        }}
                    >
                        <TextArea
                            rows={4}
                            placeholder="Enter prompt"
                            value={prompt}
                            onChange={(e) => setPrompt(e.target.value)}
                        />
                        <p>OR</p>
                        <ImagePicker
                            trigger={
                                <Button size="medium" icon={<UploadOutlined />}>
                                    Select Design Image
                                </Button>
                            }
                            many={false}
                            defaultTab="collection"
                            onSelect={(images) => {
                                const one = images[0];
                                log.d(one, "selected image");
                                setImg(one);
                                setPrompt("");
                                mutationImg.mutate({
                                    image_url: getPublicImageURL(one?.id),
                                });
                            }}
                        />
                    </div>
                    <br />
                    <Space style={{ marginTop: "1rem" }}>
                        <Button
                            type="primary"
                            onClick={() => {
                                if (prompt?.length > 0) {
                                    mutation.mutate({ prompt, publish: true });
                                } else if (img) {
                                    mutationImg.mutate({
                                        image_url: getPublicImageURL(img?.id),
                                    });
                                }
                            }}
                            loading={
                                mutation.isLoading || mutationImg.isLoading
                            }
                        >
                            Generate
                        </Button>
                        <Button>Render</Button>
                    </Space>
                </div>
                {result && (
                    <div style={{ height: "70vh" }}>
                        <QurealCanvas
                            key={result?.id}
                            item={result}
                            slug={result["slug"]}
                            is_template={false}
                            prefill={{}}
                            me={me}
                            // closeBtn={closeBtn}
                            // close_left={close_left}
                            // open_cust={open_cust}
                            // setOpenCust={setOpenCust}
                        />
                    </div>
                )}
                {result && (
                    <MessageCodeView
                        data={{ language: "json", code: result }}
                    />
                )}
            </div>
        </QurealSection>
    );
}

export default QZeroTest;
